import { TextField } from "@dash/form";
import type { FC } from "react";

import { SupportTicketLinkedInvoice } from "./SupportTicketLinkedInvoice";

type Props = {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  isDisabled?: boolean;
};

export const SupportTicketInvoiceNumberField: FC<Props> = ({ value, onChange, onBlur, isDisabled }) => {
  return (
    <>
      <TextField
        label="Numer faktury"
        value={value}
        onChange={onChange}
        isDisabled={isDisabled}
        inputElementProps={{
          onBlur,
          onKeyDown: (event) => {
            if (event.key === "Enter") {
              event.currentTarget.blur();
            }
          },
        }}
      />
      <SupportTicketLinkedInvoice invoiceNumber={value} />
    </>
  );
};
